import { z } from 'zod';

const CurrencyAndAmountSchema = z.object({
  currency: z.string(),
  amount: z.string().nullable(),
});

export const DepositConfig = z.object({
  supportedBankAccountCodes: z.array(z.string()).nullable(),
  minDepositAmount: CurrencyAndAmountSchema,
  dailyMaxDepositAmount: CurrencyAndAmountSchema,
  monthlyMaxDepositAmount: CurrencyAndAmountSchema,
  feeAmount: CurrencyAndAmountSchema,
  dailyTransactionCount: z.number(),
  monthlyTransactionCount: z.number(),
  currencyDailyTransactionCount: z.number(),
  currencyMonthlyTransactionCount: z.number(),
  reviewTimeDescription: z.string(),
  reviewTime: z.object({
    min: z.string(),
    max: z.string(),
    unit: z.string(),
  }),
  dailyQuota: z.number(),
  monthlyQuota: z.number(),
});

export const PaymentConfig = z.object({
  name: z.string(),
  fullName: z.string(),
  vibanType: z.string(),
  depositVibanTypes: z.array(z.string()),
  reviewTimeDescription: z.string(),
  reviewTime: z.object({
    min: z.string(),
    max: z.string(),
    unit: z.string(),
  }),
  bankTransferTimeDescription: z.string(),
  bankTransferTime: z.object({
    min: z.string(),
    max: z.string(),
    unit: z.string(),
  }),
  minPaymentAmount: CurrencyAndAmountSchema,
  dailyMaxPaymentAmount: CurrencyAndAmountSchema,
  monthlyMaxPaymentAmount: CurrencyAndAmountSchema,
  autoApproveMaxPaymentAmount: CurrencyAndAmountSchema,
  globalDailyMaxPaymentAmount: CurrencyAndAmountSchema,
  currencyDailyMaxPaymentAmount: CurrencyAndAmountSchema,
  currencyMonthlyMaxPaymentAmount: CurrencyAndAmountSchema,
  feeAmount: CurrencyAndAmountSchema,
  refundFeeAmount: CurrencyAndAmountSchema,
});

export const GetFiatConfigResultSchema = z.object({
  deposit: DepositConfig,
  payment: PaymentConfig,
});

export type GetFiatConfigResult = z.infer<typeof GetFiatConfigResultSchema>;
